import React, { useEffect, useState } from "react";
import Table from "../../../Extracomponents/Table";
import {
  getMySubscription,
  GETServiceData,
  getMyBasketSubscription,
} from "../../../Services/UserService/User";
import Content from "../../../components/Contents/Content";
import { fDate, fDateTime } from "../../../../Utils/Date_formate";
import ReusableModal from "../../../components/Models/ReusableModal";
import Loader from "../../../../Utils/Loader";
import { useLocation } from "react-router-dom";

const Subscription = () => {
  const token = localStorage.getItem("token");
  const location = useLocation();
  const newActiveTab = location?.state?.activeTab || {};

  const [planData, setPlanData] = useState([]);

  const [basketData, setBasketData] = useState([]);

  const [activeTab, setActiveTab] = useState(
    newActiveTab === "basket" ? "basket" : "plan",
  );
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [discription, setDiscription] = useState("");
  const id = localStorage.getItem("id");
  const [isLoading, setIsLoading] = useState(true);
  const [servicedata, setServicedata] = useState([]);

  useEffect(() => {
    if (activeTab === "plan") {
      fetchMySubscription();
      fetchMyService();
    } else if (activeTab === "basket") {
      fetchBasketMySubscription();
    }
  }, [activeTab]);

  const fetchMySubscription = async () => {
    try {
      const res = await getMySubscription(id, token);

      if (res?.status) {
        setPlanData(res?.data);
      } else {
        setPlanData([]);
      }
    } catch (err) {
      console.log("erorr");
    }
    // setIsLoading(false)
  };

  const fetchBasketMySubscription = async () => {
    try {
      const res = await getMyBasketSubscription(id, token);
      if (res?.status) {
        setBasketData(res?.data);
      } else {
        setBasketData([]);
      }
    } catch (err) {
      console.log("erorr");
    }
    setIsLoading(false);
  };

  const fetchMyService = async () => {
    try {
      const res = await GETServiceData(id, token);
      if (res?.status) {
        setServicedata(res?.data);
      }
    } catch (err) {
      console.log("erorr");
    }
    setIsLoading(false);
  };

  const handleViewClick = (plan) => {
    setDiscription(plan);
  };

  const renderAccordionItems = () => {
    return planData?.map((accordion) => (
      <div
        key={accordion._id}
        className="accordion-item rounded-3 border-0 shadow mb-2"
      >
        <h2 className="accordion-header">
          <button
            className="accordion-button border-bottom collapsed fw-semibold"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target={`#flush-collapse${accordion._id}`}
            aria-expanded="false"
            aria-controls={`flush-collapse${accordion._id}`}
          >
            <div className="d-flex justify-content-between align-items-center w-100">
              <div>
                <h5 className="mb-2 text-white">
                  {accordion?.categoryDetails?.title} (
                  {accordion?.serviceNames?.map((value) => value).join("+ ")})
                </h5>
                <p className="m-0 pe-2">
                  Expires on: {fDateTime(accordion?.plan_end) || "-"}
                </p>
              </div>
              <p className="m-0 pe-2">
                {/* <span className="badge bg-success rounded-pill text-capitalize" >
                  {accordion?.planDetails?.status === "inactive" ? "" : "Active"}
                </span> */}
                <span
                  className={`badge rounded-pill ${
                    new Date(accordion?.plan_end) < new Date()
                      ? "bg-danger"
                      : "bg-success"
                  }`}
                >
                  {new Date(accordion?.plan_end) < new Date()
                    ? "Expired"
                    : "Active"}
                </span>
              </p>
            </div>
          </button>
        </h2>
        <div
          id={`flush-collapse${accordion._id}`}
          className="accordion-collapse collapse"
          data-bs-parent="#accordionFlushExample"
        >
          <div className="accordion-body">
            <div className="card shadow-sm mb-3">
              <div className="card-header d-flex justify-content-between align-items-center border-bottom">
                <h5 className="mb-0 text-yellow">
                  {accordion?.categoryDetails?.title}
                </h5>
                <button
                  className="btn btn-primary"
                  onClick={() =>
                    handleViewClick(accordion?.planDetails?.description)
                  }
                >
                  View
                </button>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-lg-6 mb-4">
                    <div
                      className="p-4 shadow rounded-4  border h-100"
                      style={{ backgroundColor: "#0e1311" }}
                    >
                      <div
                        className="mb-3 text-center py-2 rounded-top-3"
                        style={{ backgroundColor: "#dbf169 " }}
                      >
                        <h4
                          className="mb-0 text-dark fs-5"
                          style={{ color: "#000" }}
                        >
                          <i className="bi bi-info-circle-fill me-2"></i>
                          Plan Details
                        </h4>
                      </div>
                      <table className="table table-bordered table-hover align-middle mb-0 text-white">
                        <tbody className="text-white">
                          <tr>
                            <td className="fw-semibold text-white">
                              {" "}
                              Plan Duration:
                            </td>
                            <td className="text-white">
                              {accordion?.planDetails?.validity || "--"}
                            </td>
                          </tr>
                          <tr>
                            <td className="fw-semibold text-white">
                              {" "}
                              Purchase On:
                            </td>
                            <td className="text-white">
                              {fDateTime(accordion?.created_at) || "--"}
                            </td>
                          </tr>
                          <tr>
                            <td className="fw-semibold text-white">
                              {" "}
                              Purchase Price:
                            </td>
                            <td>
                              <span className="badge bg-success fs-6 ">
                                ₹{accordion?.total?.toFixed(2)}
                              </span>
                              {accordion?.plan_price !== accordion?.total &&
                                accordion?.gst && (
                                  <small className="text-light ms-1">
                                    ({accordion?.gst}% Tax included)
                                  </small>
                                )}
                            </td>
                          </tr>
                          <tr>
                            <td className="fw-semibold text-white">
                              {" "}
                              Expired On:
                            </td>
                            <td className="text-white">
                              {fDateTime(accordion?.plan_end) || "--"}
                            </td>
                          </tr>
                          <tr>
                            <td className="fw-semibold text-white">
                              {" "}
                              Plan Price:
                            </td>
                            <td>
                              <span className="badge bg-primary text-white">
                                ₹{(accordion?.plan_price ?? "--")?.toFixed(2)}
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td className="fw-semibold text-white">
                              {" "}
                              Discount:
                            </td>
                            <td>
                              <span className="badge bg-warning text-dark">
                                ₹ {accordion?.discount?.toFixed(2) ?? "--"}
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td className="fw-semibold text-white">
                              {" "}
                              Start Date:
                            </td>
                            <td className="text-white">
                              {fDateTime(accordion?.plan_start) ||
                                "Make By Admin"}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="col-lg-6 mb-4">
                    <div
                      className="p-4 shadow rounded-4 border h-100"
                      style={{ backgroundColor: "#0e1311" }}
                    >
                      <div
                        className="mb-3 text-center text-white py-2 rounded-top-3"
                        style={{ backgroundColor: "#dbf169 " }}
                      >
                        <h4
                          className="mb-0 text-dark fs-5"
                          style={{ color: "#000" }}
                        >
                          <i className="bi bi-clock-history me-2"></i>
                          Payment History
                        </h4>
                      </div>
                      <table className="table table-bordered table-hover align-middle mb-0">
                        <tbody>
                          <tr>
                            <td className="fw-semibold text-white">
                              {" "}
                              Paid Amount:
                            </td>
                            <td className="text-white">
                              {accordion?.total?.toFixed(2) ?? "--"}
                            </td>
                          </tr>
                          <tr>
                            <td className="fw-semibold text-white">
                              {" "}
                              Plan Discount:
                            </td>
                            <td className="text-start">
                              <span className="badge bg-success text-white">
                                ₹{accordion?.discount?.toFixed(2) ?? "--"}
                              </span>
                            </td>
                          </tr>
                          <tr>
                            <td className="fw-semibold text-white ">
                              {" "}
                              Purchase Type:
                            </td>
                            <td className="text-white">
                              {accordion?.orderid
                                ? "Online"
                                : "Assigned by Admin"}
                            </td>
                          </tr>
                          {/* <tr>
  <td className="fw-semibold text-white">Purchase Type:</td>
  <td className="text-white">
    {accordion?.orderid === "free"
      ? "Discounted"
      : accordion?.orderid
      ? "Online"
      : "Assigned by Admin"}
  </td>
</tr> */}
                          <tr>
                            <td className="fw-semibold text-white ">
                              {" "}
                              Plan Validity:
                            </td>
                            <td className="text-white">
                              {accordion?.planDetails?.validity || "--"}
                            </td>
                          </tr>
                          <tr>
                            <td className="fw-semibold text-white ">
                              {" "}
                              Order Id:
                            </td>
                            <td className="text-white">
                              {accordion?.orderid || "NA"}
                            </td>
                          </tr>
                          <tr>
                            <td className="fw-semibold text-white ">
                              {" "}
                              Used Coupon:
                            </td>
                            <td className="text-white">
                              {accordion?.coupon || "NA"}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    ));
  };

  const renderAccordionItems1 = () => {
    return (
      basketData &&
      basketData?.map((accordion) => (
        <div
          key={accordion._id}
          className="accordion-item rounded-3 border-0 shadow mb-2"
        >
          <h2 className="accordion-header">
            <button
              className="accordion-button border-bottom collapsed fw-semibold"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#flush-collapse${accordion._id}`}
              aria-expanded="false"
              aria-controls={`flush-collapse${accordion._id}`}
            >
              <div className="d-flex justify-content-between align-items-center w-100">
                <div>
                  <h4 className="m-0 text-white">
                    {accordion?.basketDetails?.title || "No Title"}
                  </h4>
                  <p className="m-0 pe-2">
                    Expires on: {fDateTime(accordion?.enddate) || "-"}
                  </p>
                </div>
                <p className="m-0 pe-2">
                  <span
                    className={`badge rounded-pill ${new Date(accordion?.enddate) > new Date() ? "bg-success" : "bg-danger"}`}
                  >
                    {new Date(accordion?.enddate) > new Date()
                      ? "Active"
                      : "Expired"}
                  </span>
                </p>
              </div>
            </button>
          </h2>

          <div
            id={`flush-collapse${accordion._id}`}
            className="accordion-collapse collapse"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="accordion-body">
              <div className="card shadow-sm mb-3">
                <div className="card-header d-flex justify-content-between align-items-center border-bottom">
                  <h5 className="mb-0">{accordion?.basketDetails?.title}</h5>
                  <button
                    className="btn btn-primary"
                    onClick={() =>
                      handleViewClick(accordion?.basketDetails?.description)
                    }
                  >
                    View
                  </button>
                </div>
                <div className="card-body">
                  <table className="table table-bordered mb-0">
                    <tbody>
                      <tr>
                        <td className="text-white">
                          <strong>Plan Duration</strong>
                        </td>
                        <td className="text-white">
                          {accordion?.validity || "--"}
                        </td>
                      </tr>
                      <tr>
                        <td className="text-white">
                          <strong>Purchased on</strong>
                        </td>
                        <td className="text-white">
                          {fDateTime(accordion?.startdate) || "--"}
                        </td>
                      </tr>
                      <tr>
                        <td className="text-white">
                          <strong>Plan Price</strong>
                        </td>
                        <td className="text-white">
                          ₹{accordion?.plan_price?.toFixed(2) || "--"}
                        </td>
                      </tr>
                      <tr>
                        <td className="text-white">
                          <strong>Purchase Price</strong>
                        </td>
                        <td className="text-white">
                          ₹
                          {(
                            accordion?.total + (accordion?.gstAmount || 0)
                          ).toFixed(2)}{" "}
                          <span style={{ color: "#6c757d", fontSize: "12px" }}>
                            (Tax include {accordion?.gst}%)
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-white">
                          <strong>Expires On</strong>
                        </td>
                        <td className="text-white">
                          {fDateTime(accordion?.enddate) || "--"}
                        </td>
                      </tr>

                      <tr>
                        <td className="text-white">
                          <strong>Discount Price</strong>
                        </td>
                        <td className="text-white">
                          ₹{accordion?.coupon || "0"}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))
    );
  };

  return (
    <div>
      <Content
        Page_title="Plan / Basket Subscription"
        button_status={false}
        backbutton_title="Back"
        backbutton_status={false}
      >
        <div className="page-content plan-subscription">
          <ul className="nav nav-pills mb-3 justify-content-center border-bottom">
            <li className="nav-item">
              <button
                className={`nav-link ${
                  activeTab === "plan" ? "active btn-primary" : ""
                }`}
                onClick={() => setActiveTab("plan")}
              >
                Plan Subscription
              </button>
            </li>
            <li className="nav-item">
              <button
                className={`nav-link ${
                  activeTab === "basket" ? "active btn-primary" : ""
                }`}
                onClick={() => setActiveTab("basket")}
              >
                Basket Subscription
              </button>
            </li>
          </ul>

          {isLoading ? (
            <Loader />
          ) : (
            <>
              {activeTab === "plan" && (
                <div>
                  <div className="row">
                    {servicedata && servicedata.length > 0 ? (
                      servicedata.map((item, index) => (
                        <div key={index} className="col-md-4 mb-3">
                          <div className="card">
                            <ul className="list-group list-group-flush mt-0">
                              <li className="list-group-item d-flex justify-content-between align-items-center headingfont text-white">
                                {item?.serviceName} <span></span>
                              </li>
                              <li className="list-group-item d-flex justify-content-between align-items-center text-white">
                                Expiry Date
                                <span className="badge bg-primary rounded-pill badgespan">
                                  {fDate(item?.enddate)}
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="text-center mt-5">
                        <img
                          src="/assets/images/nodata.png"
                          alt="No Records Found"
                          className="w-25"
                        />
                      </div>
                    )}
                  </div>
                  <div className="mt-4">
                    <div
                      className="accordion accordion-flush"
                      id="accordionFlushExample"
                    >
                      {renderAccordionItems()}
                    </div>
                  </div>
                </div>
              )}

              {activeTab === "basket" &&
                (basketData && basketData.length > 0 ? (
                  <div className="mt-4">
                    <div
                      className="accordion accordion-flush"
                      id="accordionFlushExample"
                    >
                      {renderAccordionItems1()}
                    </div>
                  </div>
                ) : (
                  <div className="text-center mt-5">
                    <img
                      src="/assets/images/nodata.png"
                      alt="No Records Found"
                      className="w-25"
                    />
                  </div>
                ))}
            </>
          )}
        </div>

        <ReusableModal
          size="xl"
          show={discription}
          onClose={() => setDiscription("")}
          title="Description"
          body={
            <>
              <div>
                <p dangerouslySetInnerHTML={{ __html: discription }} />
              </div>
              <style jsx>{`
                .modal-body img {
                  max-width: 100%;
                  max-height: 100%;
                  object-fit: contain;
                }
              `}</style>
            </>
          }
        />
      </Content>

      {selectedPlan && (
        <div
          className="modal fade"
          id="planModal"
          tabIndex="-1"
          aria-labelledby="planModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="planModalLabel">
                  {selectedPlan?.categoryDetails?.title}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <h6>Description</h6>
                <p>
                  {selectedPlan?.categoryDetails?.description ||
                    "No description available."}
                </p>
                <table className="table table-bordered">
                  <tbody>
                    <tr>
                      <td className="text-white">
                        <strong>Plan Duration:</strong>
                      </td>
                      <td>{selectedPlan?.planDetails?.validity || "--"}</td>
                    </tr>
                    <tr>
                      <td className="text-white">
                        <strong>Purchased On:</strong>
                      </td>
                      <td>{selectedPlan?.plan_start || "--"}</td>
                    </tr>
                    <tr>
                      <td className="text-white">
                        <strong>Plan Price:</strong>
                      </td>
                      <td>₹{selectedPlan?.plan_price || "--"}</td>
                    </tr>
                    <tr>
                      <td className="text-white">
                        <strong>Expiry On:</strong>
                      </td>
                      <td>{selectedPlan?.plan_end || "--"}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Subscription;
